export default __webpack_public_path__ + "static/media/about.4535f3fc.jpg";